import {unJsonp} from "../../assets/js/http";

const state = {
  userOnlyId: '',
}

const getters = {
  getUserOnlyId(state: any) {
    return state.userOnlyId;
  }
}

const actions = {
  getUserOnlyIdAsync(context: any) {
    unJsonp("//my" + process.env.VUE_APP_URI_DOMAIN +"/usr/getIndexCookies.do",{jsonp: 'jsonCallBack'})
    .then((data:any) => {
        context.commit('setUserOnlyId', data.body.useronlyid)
    })
  }
}

const mutations = {
  setUserOnlyId(state: any, res: any) {
      state.userOnlyId=res;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
